import { handleAction } from '@mendeley-internal/lib-js-redux-actions';
import { getTypes } from '../actions/types';

export default handleAction(getTypes, {
  next(state, { payload }) {
    return payload.reduce((newState, { name, description }) => ({
      ...newState,
      [name]: description
    }), {});
  },
  throw() {
    return {};
  }
}, null);



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/types.js